import React, { FC } from 'react';
import { IConversationRunContainer } from '../model/containers/ConversationRunContainer';
import { useContainerRendererFactory } from './hooks/useContainerRendererFactory';
import { useThrottledEventRefresher } from '@zdrbm/zdr-react';
import { IConversationRun } from '../model/ConversationRun';

export interface AssistantContainerResponseProps {
    run: IConversationRun;
    container: IConversationRunContainer;
    isLastRun: boolean;
}

export const AssistantContainerResponse: FC<AssistantContainerResponseProps> = React.memo(({
    container,
    run,
    isLastRun,
}) => {
    const rendererFactory = useContainerRendererFactory();
    // We use useThrottledEventRefresher and not useEventRefresher due to the nature of streaming where many updates can
    // come in quick succession. This throttles the updates to avoid a case where some text updates aren't reaching the
    // UI since internally the UI updates are dependent on a timestamp and with useEventRefresher some updates can be
    // lost because they'll have the same timestamp.
    // Ideally, useEventRefresher should take care of this, but at the moment it does not,
    // so we use throttling here with a dedicated hook.
    useThrottledEventRefresher(1, container.data);
    const renderer = container.selectFromFactory(rendererFactory);

    const renderResult = renderer.render(run, container);

    return (
        <>
            {renderResult?.content ?? null}
            {isLastRun && (renderResult?.userActions ?? null)}
        </>
    );
});
